let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("gPQs2")).then(() => parcelRequire('2lRM4'));